import React from 'react'
import PropTypes from 'prop-types'
import { Margin, Text, Grid, Row, Col } from 'shared/components'
import { auth } from 'routes/route.map'
import { TransitionLink } from 'local/components'

import LoginForm from './components/loginForm'
import MobileLoginForm from './components/mobileLoginForm'

import * as styles from './styles'

const NewLoginComponent = ({ onSubmit }) => (
  <>
    {/* Mobile and Tablet View */}
    <div css={styles.mobileView}>
      <MobileLoginForm onSubmit={onSubmit} />
    </div>

    {/* Desktop View */}
    <div css={styles.desktopView}>
      <Grid>
        <Row middle="xs" css={styles.loginContainer}>
          <Col lg={4} xs={0}>
            <img src="./img/newAuth/login.png" css={styles.loginImgBanner} />
          </Col>
          <Col lg={2} xs={0} />

          <Col lg={4} xs={12}>
            <section css={styles.loginSection}>
              <div css={styles.formInfo}>
                <Margin bottom={2}>
                  <Text as="h2" size={16} white italic bold>
                    Log In
                  </Text>
                </Margin>

                <TransitionLink
                  text="Don't have an account?"
                  linkText="Sign up"
                  to={auth.signup()}
                  size={11}
                />
              </div>

              <Margin as="section" tb={2} css={{ minWidth: 300 }}>
                <LoginForm onSubmit={onSubmit} />
              </Margin>
            </section>
          </Col>
          <Col lg={2} xs={0} />
        </Row>
      </Grid>
    </div>
  </>
)

NewLoginComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default NewLoginComponent
